import { render, staticRenderFns } from "./payChannelInfo.vue?vue&type=template&id=2a2bae56&scoped=true&"
import script from "./payChannelInfo.vue?vue&type=script&lang=js&"
export * from "./payChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./payChannelInfo.vue?vue&type=style&index=0&id=2a2bae56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2bae56",
  null
  
)

export default component.exports